export { default, type ParticipantsSectionProps } from './ParticipantsSection';
